import { render } from "./ProjectCards.vue?vue&type=template&id=684a0198&scoped=true"
import script from "./ProjectCards.vue?vue&type=script&lang=js"
export * from "./ProjectCards.vue?vue&type=script&lang=js"

import "./ProjectCards.vue?vue&type=style&index=0&id=684a0198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684a0198"]])

export default __exports__